import { ChevronRight } from "@mui/icons-material";
import {
  Box,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  useTheme,
} from "@mui/material";
import { Icon } from "@iconify/react";
import { useTranslation } from "react-i18next";
import { Block } from "../../../../shared";

// Все внешние ссылки Zero Wallet держим в .env — так проще менять
// без правки кода. Fallback'и совпадают с прод-адресами.
const TELEGRAM_URL =
  process.env.REACT_APP_TELEGRAM_CHANNEL_URL || "https://t.me/ZeroWalletChannel";
const INSTAGRAM_URL =
  process.env.REACT_APP_INSTAGRAM_URL || "https://www.instagram.com/zero_wallet";
const TWITTER_URL =
  process.env.REACT_APP_TWITTER_URL || "https://x.com/zero_wallet_";
const WEBSITE_URL =
  process.env.REACT_APP_WEBSITE_URL || "https://zero-wallet.net";

interface SocialItem {
  labelKey: string;
  icon: string;
  url: string;
  telegram?: boolean;
}

const SOCIAL_ITEMS: SocialItem[] = [
  {
    labelKey: "blocks.channel",
    icon: "mdi:telegram",
    url: TELEGRAM_URL,
    telegram: true,
  },
  {
    labelKey: "blocks.instagram",
    icon: "mdi:instagram",
    url: INSTAGRAM_URL,
  },
  {
    labelKey: "blocks.twitter",
    icon: "prime:twitter",
    url: TWITTER_URL,
  },
  {
    labelKey: "blocks.site",
    icon: "solar:planet-linear",
    url: WEBSITE_URL,
  },
];

function openLink(item: SocialItem) {
  if (item.telegram) {
    Telegram.WebApp.openTelegramLink(item.url);
  } else {
    Telegram.WebApp.openLink(item.url);
  }
}

export function SocialMediaBlock() {
  const theme = useTheme();
  const { t } = useTranslation("profile");
  const dividerColor =
    theme.palette.mode === "dark" ? "#26262A" : "rgba(239, 239, 243, 1)";

  return (
    <Block sx={{ paddingTop: "4px", paddingBottom: "4px" }}>
      {SOCIAL_ITEMS.map((item, idx) => {
        const isLast = idx === SOCIAL_ITEMS.length - 1;
        return (
          <Box key={item.labelKey}>
            <ListItem
              onClick={() => openLink(item)}
              sx={{
                paddingInline: 0,
                paddingBlock: "8px",
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "12px",
                cursor: "pointer",
              }}
            >
              <ListItemIcon
                sx={(theme) => ({
                  backgroundColor:
                    theme.palette.mode === "dark"
                      ? "rgba(51,119,255,0.16)"
                      : "rgba(51,119,255,0.10)",
                  color: theme.palette.primary.main,
                  minWidth: "36px",
                  width: "36px",
                  height: "36px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "10px",
                  flexShrink: 0,
                })}
              >
                <Icon icon={item.icon} width={20} height={20} />
              </ListItemIcon>

              <ListItemText
                sx={{ margin: 0, flexGrow: 1 }}
                primary={
                  <Typography sx={{ fontSize: "15px", fontWeight: 500 }}>
                    {t(item.labelKey)}
                  </Typography>
                }
              />

              <ChevronRight sx={{ color: "#b0b0b0", flexShrink: 0 }} />
            </ListItem>
            {!isLast && (
              <Box
                sx={{
                  height: "1px",
                  backgroundColor: dividerColor,
                  marginLeft: "48px",
                }}
              />
            )}
          </Box>
        );
      })}
    </Block>
  );
}
